import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import TableHeader from '../../../../components/Table/TableHeader';
import TableRow from '../../../../components/Table/TableRow';
import projectIcon from '../../../../assets/images/projects-icon-light-gray.svg';
import addIcon from '../../../../assets/images/add-icon-gray.svg';
import Home from '../../../../containers/Home';
import dataModel from '../../../../models/DataModel';

import './ProjectReportTable.scss';
import LoadingDots from '../../../../components/LoadingDots';

export class ProjectReportTable extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      sortedType: this.props.sortField,
      sortAsc: this.props.ascending,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.accent != this.props.accent) {
      this.setState({ accent: this.props.accent });
    }
    if (prevProps.filter != this.props.filter || prevProps.searchString != this.props.searchString) {
      this.infiniteDone = false;
    }
  }

  handleScrolling() {
    const listRect = this.list.getBoundingClientRect();
    const scrollRect = this.scroller.getBoundingClientRect();
    if (
      !this.infiniteDone && 
      listRect.bottom <= scrollRect.bottom + 8 && !this.scrollinProgress &&
      ((this.props.reportProjects && this.props.reportProjects.length < this.props.totalProjects))
    ) {
      this.scrollinProgress = true;
      this.setState({ loadingMore: true });

      if (this.props.getMoreProjects) {
        this.props.getMoreProjects().then(fetchedProjects => {
          if (fetchedProjects.length >= this.props.totalProjects) {
            this.infiniteDone = true;
          }
          this.scrollinProgress = false;
          this.setState({ loadingMore: false });
        });
      }
    }
  }

  handleSort(type, direction) {
    if (type == this.state.sortedType && direction == 'up' && this.state.sortAsc) {
      this.setState({ sortedType: null });
      this.infiniteDone = false;
      this.props.handleSortChange(null, null, this.props.permissions);
    }
    else if (type == this.state.sortedType && direction == 'down' && !this.state.sortAsc) {
      this.setState({ sortedType: null  });
      this.infiniteDone = false;
      this.props.handleSortChange(null, null, this.props.permissions);
    }
    else {
      this.props.handleSortChange(type, direction == 'up' ? true : false, this.props.permissions);
      this.infiniteDone = false;
      
      this.setState({
        sortedType: type,
        sortAsc: direction == 'up' ? true : false, 
      });
    }
  }

  handleCreateProjectRows(){
    const { accent } = this.props;
    let even = false;
    let rows;
    let actualProjects = this.props.reportProjects;

    if (actualProjects) {
      this.filteredProjects = actualProjects;
      rows = actualProjects.map(project => {
        even = !even;
        return (
            <TableRow
              key={project.id}
              selectedItem={ project }
              even={ even }
              select={ this.handleSelectProject }
              type={'project-report'}
              accent={accent ? accent : '#CD03A'} 
            />
          );
      });
    }
    return rows;
  }

  handleSelectProject(project) {
    if (this.props.selectProject) {
      this.props.selectProject(project);
    }
  }

  handleCaretSelection(direction) {
    this.direction = direction;
  }

  handleAddButtonClicked(){
    this.props.history.push('/reportProjects?add_project=true');
  }

  handleSetScroller(element) {
    if (element && !this.scroller) {
      this.scroller = element;
      this.scroller.addEventListener('scroll', this.handleScrolling);
    }
  }

  render() {
    let { accent } = this.props;
    const sortDirectionClass  = this.state.sortAsc ? '' : 'down';

    let caretTypes = [
      { type: 'location_id', headerName: this.textMap.locationId.toUpperCase(), first: true }, 
      { type: 'contract_id', headerName: 'CONTRACT ID' }, 
      { type: 'project_name', headerName: (this.textMap.project + ' name').toUpperCase() }, 
      { type: 'site_name', headerName: this.textMap.siteName.toUpperCase() },
      { type: 'address', headerName: this.textMap.address.toUpperCase() }, 
      { type: 'project_type', headerName: this.textMap.projectType.toUpperCase() },
      { type: 'project_manager', headerName: this.textMap.projectManager.toUpperCase() },
      { type: 'created_at', headerName: 'CREATED' },
      { type: 'status', headerName: this.textMap.projectStatus.toUpperCase() },
    ];

    let tableHeader = (
      <TableHeader 
        accent={ accent } 
        sortDirectionClass={ sortDirectionClass }
        handleSort={ this.handleSort }
        sortedType={ this.state.sortedType }
        caretTypes={ caretTypes } 
        reportType={'project-report'}
      />
    );

    let projectRows = this.handleCreateProjectRows();

    let loadingMore = null;
    if (this.state.loadingMore) {
      loadingMore = <div className="loading-more-indicator"><LoadingDots /></div>;
    }

    if ((!projectRows || projectRows.length == 0) && !this.props.projectRefreshing) {
      if (this.props.filter || this.props.searchString) {
        projectRows = <div className="no-matches-indicator">No Results Found...</div>;
      }
      else if (!this.props.refresh){
        tableHeader = null;
        let noProjectsText = <div className="no-projects">No reportProjects found.</div>;
        if (this.props.permissions.canCreateProject) {
          noProjectsText = <div className="no-projects">There are no projects created yet for this company. <br />Select <img alt='button' className='add-button' src={addIcon} onClick={this.handleAddButtonClicked} /> to add a project.</div>;
        }

        projectRows = <div className='no-projects-container'>
          <img className='project-icon' src={projectIcon} alt='icon' />
          {noProjectsText}
        </div>;
      }
    }
    let waitSpinner;
    if(this.props.projectRefreshing){
      waitSpinner = <Home type="transparent" />;
    }

    return <div className={'project-report-table'}>
      {tableHeader}  
      <div className={'project-report-scroller infinite-scrolling'} ref={(element) => this.handleSetScroller(element)}>  
        <div className='project-report-rows' ref={(element) => {
          this.list = element;
        }}>
          {waitSpinner}
          {projectRows}
          {loadingMore}
        </div>
      </div>  
    </div>;
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  let accent = state.new_companies.currentCompany ? state.new_companies.currentCompany.accent_color : null;
  return {
    dataModel: dataModel,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    accent: accent,
  };
};
export default withRouter(connect(mapStateToProps)(ProjectReportTable));



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ProjectReport/ProjectReportTable/index.js